<template>
  <v-layout wrap align-start>
    <v-flex xs10 md4>
      <v-layout row>
        <v-flex xs12 sm4 md3>
          <v-subheader>Clients:</v-subheader>
        </v-flex>
        <v-flex xs12 sm8 md7>
          <v-select
            id="clients"
            v-model="dataOfClientsID"
            :items="dataOfClients"
            label="No client"
            class="ex-dropdown"
            item-text="text"
            solo
            @change="$emit('selectedClient', dataOfClientsID)"
          >
          </v-select>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs10 md4>
      <v-layout row>
        <v-flex xs12 sm4>
          <v-subheader>Products Status:</v-subheader>
        </v-flex>
        <v-flex xs12 sm8 md7>
          <v-select
            id="status"
            @change="updateByFilters($event)"
            :value="getSelectedFilters.list"
            v-model="dataOfProductsFiltersID"
            :items="dataOfProductsFilters"
            label="No Selection"
            :background-color="statusColor"
            class="ex-dropdown"
            item-text="text"
            solo
          >
          </v-select>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
/* eslint-disable */
export default {
  name: "ClientFilter",
  props: {
    getSelectedFilters: {
      type: Object,
    },
  },
  data: () => ({
    statusColor: "rgb(10 255 17 / 37%)",
    dataOfClientsID: "0",
    dataOfProductsFiltersID: "active",
    dataOfClients: [{ value: "0", text: "No client" }],
    dataOfProductsFilters: [
      { value: "active", text: "Active Products" },
      { value: "pending", text: "Pending Products" },
    ],
  }),
  created() {
    this.gettingClients();
  },
  methods: {
    updateByFilters(data) {
      this.statusColor =
        data === "active" ? "rgb(10 255 17 / 37%)" : "rgb(249 165 11 / 94%)";
      this.$emit("updateByFilters", data, "list");
    },
    gettingClients() {
      // this.$store.dispatch("productModule/gettingClients").then((res) => {
        // this.$store.commit("globalModule/SET_CLIENTS", res.data.clients)
      // ----- the clients will be stored into global module -----
      this.$store.dispatch("globalModule/GET_CLIENTS").then((res) => {
        Array.from(res.data.clients).forEach((item) =>
          this.dataOfClients.push(item)
        );
      });
    },
  },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/product/ClientFilter.vue